module.exports = __webpack_public_path__ + "static/media/stories-top-icons.8575b3ae.svg";